/** Extract a FastAPI error message without trusting the response shape. */
export function parseApiError(data: unknown): string | null {
  if (typeof data !== 'object' || data === null || !('detail' in data)) {
    return null;
  }
  if (typeof data.detail === 'string') return data.detail;
  if (!Array.isArray(data.detail)) return null;

  const first: unknown = data.detail[0];
  if (typeof first === 'object' && first !== null && 'msg' in first && typeof first.msg === 'string') {
    return first.msg;
  }
  return null;
}

/** Read the body once; preserve the fallback for empty or non-JSON errors. */
export async function readApiError(response: Response, fallback: string): Promise<string> {
  try {
    const data: unknown = await response.json();
    return parseApiError(data) ?? fallback;
  } catch {
    return fallback;
  }
}
